<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>將Trinka集成到您的企業中</h1>
                        <p style="margin: 0 0 10px 0;">Trinka 企業版可以無限訪問它的所有強大功能。</p>
                        <p>輕鬆將Trinka集成到您的企業工作流程中，並且讓您的團隊使用Trinka的所有強大功能。</p>
                            <!-- <button routerLink="/contactus">Get Started</button> -->
                            <button style="margin: 0; padding: 0;" (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup" class="plansButtons"
                                type="submit">聯繫我們</button>
                        <!-- <a href="https://cloud.trinka.ai/signin?_rg=TW" target="_blank">Get Started</a> -->
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/enterprise_banner_img.png" alt="enterprise banner">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>深受全球領導者信賴</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/j-j.png" alt="JJ">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/oxford.png" alt="oxford">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/HarvardMedicalSchool.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/merck.png" alt="merck">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/cambridge.png" alt="">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/PrincetonUniversity.png" alt="Princeton University">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/biogen.png" alt="biogen">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/UNSW.png" alt="UNSW">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/accelera.png" alt="accelera">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/pfizer.png" alt="pfizer">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>旨在提高寫作水準的行業定制解決方案</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka可以幫助您的團隊高效創建專業文檔，同時確保高品質和一致性。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>生命科學、醫學和製藥</h3>
                        </div>
                        <p>Trinka強大的人工智慧深度瞭解醫學和科學寫作所需的技術複雜性和精確度，能夠根據上下文和特定主題為您提供建議。
                        </p>
                        <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']">閱讀更多
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>語言服務、出版和媒體</h3>
                        </div>
                        <p>使您的團隊能夠更一致地寫作、更快地發佈，並且提升客戶體驗，在不影響寫作品質的前提下減少寫作時間和降低成本。</p>
                        <a [routerLink]="['/enterprise/language-services-publishing-and-media']">閱讀更多
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>學術機構</h3>
                        </div>
                        <p>Trinka將編輯您的寫作，使其符合學術寫作慣例，成為最佳範例並且做好出版準備。</p>
                        <a [routerLink]="['/enterprise/academic-institutions']">閱讀更多
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>K-12和數位化學習</h3>
                        </div>
                        <p>Trinka的先進人工智慧不僅可以幫助學生提高寫作水準，還可以在寫作的同時學習最佳的學術寫作範例。</p>
                        <a [routerLink]="['/enterprise/k12-and-elearning']">閱讀更多
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>技術平台</h3>
                        </div>
                        <p>Trinka允許您輕鬆地在應用程式中添加即時編寫支援。透過提供Trinka的寫作建議來構建獨特的解決方案。</p>
                        <a [routerLink]="['/enterprise/technology-platforms']">閱讀更多
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="other_comparision">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>旨在提高寫作水準的行業定制解決方案</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka可以幫助您的團隊高效創建專業文檔，同時確保高品質和一致性。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>生命科學、醫學和製藥</h3>
                        </div>
                        <p>Trinka強大的人工智慧深度瞭解醫學和科學寫作所需的技術複雜性和精確度，能夠根據上下文和特定主題為您提供建議。
                        </p>
                        <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']">閱讀更多
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>語言服務、出版和媒體</h3>
                        </div>
                        <p>使您的團隊能夠更一致地寫作、更快地發佈，並且提升客戶體驗，在不影響寫作品質的前提下減少寫作時間和降低成本。</p>
                        <a [routerLink]="['/enterprise/language-services-publishing-and-media']">閱讀更多
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>學術機構</h3>
                        </div>
                        <p>Trinka將編輯您的寫作，使其符合學術寫作慣例，成為最佳範例並且做好出版準備。</p>
                        <a [routerLink]="['/enterprise/academic-institutions']">閱讀更多
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>K-12和數位化學習</h3>
                        </div>
                        <p>Trinka的先進人工智慧不僅可以幫助學生提高寫作水準，還可以在寫作的同時學習最佳的學術寫作範例。</p>
                        <a [routerLink]="['/enterprise/k12-and-elearning']">閱讀更多
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 paddingRightRemove">
                    <div class="features_cards">
                        <div class="features_cardsHeading">
                            <h3>技術平台</h3>
                        </div>
                        <p>Trinka允許您輕鬆地在應用程式中添加即時編寫支援。透過提供Trinka的寫作建議來構建獨特的解決方案。</p>
                        <a [routerLink]="['/enterprise/technology-platforms']">閱讀更多
                            <i class="fa fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>整合Trinka的3種方法</h2>
                        <div class="HeadingSubLine"></div>
                        <p>增強團隊的寫作能力。企業用戶可獲得無限的存取權限並獲得更多好處。選擇最適合您需要的選項組合。</p>
                    </div>
                </div>
            </div>
            <div class="row divider_line_section">
                <div class="col-lg-5">
                    <div class="integreate_img_section GetTrinkaJs_img">
                        <img class="getTrinkajs_gif_img" src="../../../assets/images/GetTrinkaJs.gif" alt="">
                        <img class="getTrinkaJs_backgrond" src="../../../assets/images/API_backgrond_layer.png" alt="">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <h3>
                            <span>01</span>獲取Trinka
                            <b style="padding: 0px 12px 4px 12px;">JS</b>
                        </h3>
                        <p>只需在瀏覽器或任何應用程式中插入一個小的JavaScript（JS）程式碼片段，即可為所有團隊成員啟用Trinka。無需複雜的集成，即可使用Trinka的強大功能。</p>
                        <ul>
                            <li>
                                <h4>簡單整合</h4>
                                <p>只需在應用程式中插入一個小的JavaScript程式碼片段，就可以讓用戶更好地使用Trinka進行寫作。</p>
                            </li>
                            <li>
                                <h4>安全可靠</h4>
                                <p>所有資料都處於高度加密的環境下。TrinkaJS是即時工作的，不會在我們的伺服器保存任何內容。 </p>
                            </li>
                            <li>
                                <h4>無與倫比的靈活性</h4>
                                <p>簡單易用的JS程式碼片段也易於集成且具有彈性，它可以隨著您不斷增長的團隊和業務輕鬆擴展。</p>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>

            <div class="row divider_line_section columu_reverse">
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <h3>
                            <span>02</span> 獲取Trinka
                            <b>API</b>
                        </h3>
                        <p>您的產品中需要Trinka嗎？Trinka強大的API使您可以輕鬆地將其集成到任何應用程式中，不但易於使用，還提供了高可靠性和可擴展性。</p>
                        <ul>
                            <li>
                                <h4>強大的API</h4>
                                <p>Trinka API提供容易取得的服務，您可以隨時獲得所需的幫助。</p>
                            </li>
                            <li>
                                <h4>API自訂</h4>
                                <p>您的應用程式有獨特的需求嗎？Trinka API的高度可定製可以滿足您的各種要求。</p>
                            </li>
                            <li>
                                <h4>無與倫比的靈活性</h4>
                                <p>Trinka功能強大的API易於使用且具有彈性，能與您的產品規模相匹配。</p>
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="integreate_img_section getTrinka_API">
                        <img class="API_bg_layer" src="../../../assets/images/API_backgrond_layer.png" alt="">
                        <img class="TrinkaAPI_img" src="../../../assets/images/TrinkaAPI_img.png" alt="">
                        <div class="API_text_section" data-aos="zoom-in">
                            <span></span>
                            <div class="API_text_overlay"></div>
                            <img src="../../../assets/images/API_text.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-5">
                    <div class="integreate_img_section getTrinka_on_premise">
                        <img src="../../../assets/images/GetTrinkaOn_Premise.png" alt="">
                        <span class="TrinkaPurpleColor"></span>
                        <span class="TrinkaredColor"></span>
                        <span class="TrinkaYellowColor"></span>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <h3>
                            <span>03</span> 獲取Trinka內部系統</h3>
                        <p>處理高度敏感的資料？Trinka內部系統是您的最佳解決方案！讓Trinka您的企業基礎架構下工作。</p>
                        <ul>
                            <li>
                                <h4>專屬支持</h4>
                                <p>借助Trinka 內部系統，您將獲得專職的服務人員與IT員工一起實現無障礙集成。</p>
                            </li>
                            <li>
                                <h4>安全可靠</h4>
                                <p>透過讓Trinka AI運行在企業基礎架構上，可以保證您資料的絕對安全。</p>
                            </li>
                            <li>
                                <h4>無可比擬的靈活性</h4>
                                <p>透過輕鬆的集成和專業的支援服務，Trinka可以輕鬆地隨著不斷增長的團隊和業務進行擴展。</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="enterprise_contactUs">
        <p>為您的企業獲取Trinka集成功能</p>
        <button (click)="sectionValue('Enterprise Form')" id="salesContactButtons" data-toggle="modal" data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">請求報價</button>
    </div>


<div class="modal custom_modal_popup enterprisePopup" id="EnterPriseContactPopup">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
                <div class="closed_icons">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="contactPopupHeading">
                            <h2>企業諮詢</h2>
                            <p *ngIf="formSection">請問您要諮詢什麼？</p>
                        </div>
                    </div>
                    <div class="inquiryTypeSection">
                        <ul class="nav nav-tabs" role="tablist" *ngIf="formSection">
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#IndividualType" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                        <defs>
                                            <style>
                                                .cls-1 {
                                                    fill: none;
                                                    stroke: #783694;
                                                    stroke-linecap: round;
                                                    stroke-linejoin: round;
                                                    stroke-width: 2px;
                                                }
                                            </style>
                                        </defs>
                                        <title>TrinkaIcons-new</title>
                                        <g id="Individual">
                                            <path class="cls-1"
                                                d="M44.83,45.13V39.82a4.65,4.65,0,0,0-1.7-3.6,62.85,62.85,0,0,0-10.89-7V22.5a4.4,4.4,0,0,0,1.56-3.36V11.39A7.9,7.9,0,0,0,25.91,3.5H24.24a7.9,7.9,0,0,0-7.89,7.89v7.75a4.32,4.32,0,0,0,1.54,3.36h0v6.68A62.22,62.22,0,0,0,7,36.22a4.62,4.62,0,0,0-1.7,3.6v5.31" />
                                        </g>
                                    </svg>
                                    <div  class="text-left">
                                        <h3>個人</h3>
                                        <span>（單用戶）</span>
                                    </div>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#OrganizationType" role="tab">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                        <defs>
                                            <style>
                                                .cls-1 {
                                                    fill: none;
                                                    stroke: #783694;
                                                    stroke-linecap: round;
                                                    stroke-linejoin: round;
                                                    stroke-width: 2px;
                                                }
                                            </style>
                                        </defs>
                                        <title>TrinkaIcons-new</title>
                                        <g id="Organization">
                                            <path class="cls-1"
                                                d="M42.87,45.13V40.06a4.45,4.45,0,0,0-1.62-3.44,60,60,0,0,0-10.41-6.72V23.51a4.2,4.2,0,0,0,1.49-3.21V12.89a7.55,7.55,0,0,0-7.54-7.54H23.19a7.55,7.55,0,0,0-7.54,7.54V20.3a4.13,4.13,0,0,0,1.47,3.21h0v6.38A59.44,59.44,0,0,0,6.71,36.62a4.42,4.42,0,0,0-1.62,3.44v5.07" />
                                            <path class="cls-1"
                                                d="M14.34,30.75a24.56,24.56,0,0,0-3.32-2V26.18a1.66,1.66,0,0,0,.59-1.27V22a3,3,0,0,0-3-3H8a3,3,0,0,0-3,3v2.93a1.63,1.63,0,0,0,.58,1.27h0v2.53a23.54,23.54,0,0,0-4.12,2.66,1.75,1.75,0,0,0-.64,1.36v2" />
                                            <path class="cls-1"
                                                d="M34.29,30.75a24.56,24.56,0,0,1,3.32-2V26.18A1.66,1.66,0,0,1,37,24.91V22a3,3,0,0,1,3-3h.63a3,3,0,0,1,3,3v2.93A1.63,1.63,0,0,1,43,26.18h0v2.53a23.54,23.54,0,0,1,4.12,2.66,1.75,1.75,0,0,1,.64,1.36v2" />
                                        </g>
                                    </svg>
                                    <div  class="text-left">
                                        <h3>組織</h3>
                                        <span>（多用戶）</span>
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div class="tab-pane" id="IndividualType" role="tabpanel" *ngIf="formSection">
                                <div class="IndividualTypeSection">
                                    <p>Trinka對於個人用戶是免費的
                                        <br />您只需註冊您的電子郵箱地址即可。</p>
                                    <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">免費註冊</a>
                                </div>
                            </div>

                            <div class="tab-pane" id="OrganizationType" role="tabpanel" *ngIf="formSection">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="contact_us_form">
                                            <form [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()">
                                                <h2>請在下面提出您的要求，我們的團隊將及時回復。</h2>
                                                <div class="row">
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('NatureBusinessType').valid && contactForm.get('NatureBusinessType').dirty) || (contactForm.get('NatureBusinessType').touched && contactForm.get('NatureBusinessType').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>業務性質*</mat-label>
                                                                <input matInput placeholder="" formControlName="NatureBusinessType" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormSubjects').valid && contactForm.get('contactFormSubjects').dirty) || (contactForm.get('contactFormSubjects').touched && contactForm.get('contactFormSubjects').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>單位名稱*</mat-label>
                                                                <input matInput placeholder="" formControlName="contactFormSubjects" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div class="textbox_content form-group textareaBox" [ngClass]="(!contactForm.get('contactFormMessage').valid && contactForm.get('contactFormMessage').dirty) || (contactForm.get('contactFormMessage').touched && contactForm.get('contactFormMessage').pristine) ? 'TextFiledError' : '' ">
                                                            <label for="">請告訴我們您的要求</label>
                                                            <textarea formControlName="contactFormMessage" class="form-control" placeholder="例如。大約的用戶數，每個用戶的每月處理字數，所需的自訂設置等。"></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormName').valid && contactForm.get('contactFormName').dirty) || (contactForm.get('contactFormName').touched && contactForm.get('contactFormName').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>您的姓名*</mat-label>
                                                                <input matInput placeholder="" formControlName="contactFormName" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('DesignationTypes').valid && contactForm.get('DesignationTypes').dirty) || (contactForm.get('DesignationTypes').touched && contactForm.get('DesignationTypes').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>指定*</mat-label>
                                                                <input matInput placeholder="" formControlName="DesignationTypes" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 rightPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactFormEmail').valid && contactForm.get('contactFormEmail').dirty) || (contactForm.get('contactFormEmail').touched && contactForm.get('contactFormEmail').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>電子郵件*</mat-label>
                                                                <input matInput placeholder="" formControlName="contactFormEmail" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6 leftPaddingRemove">
                                                        <div class="textbox_content form-group" [ngClass]="(!contactForm.get('contactphoneNo').valid && contactForm.get('contactphoneNo').dirty) || (contactForm.get('contactphoneNo').touched && contactForm.get('contactphoneNo').pristine) ? 'TextFiledError' : '' ">
                                                            <mat-form-field appearance="outline">
                                                                <mat-label>聯絡電話（包括國際代碼）</mat-label>
                                                                <input type="number" matInput placeholder="" formControlName="contactphoneNo" class="form-control">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-group text-center">
                                                    <button type="submit">送出</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="thank_section contact_us_form" *ngIf="thankSection">
                                <div class="form-group">
                                    <h2>感謝您！</h2>
                                    <p>我們會儘快和您聯絡。</p>
                                    <!-- <button data-dismiss="modal">Close</button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
